import { sortBy } from 'lodash-es'
import { compareDesc } from 'date-fns/esm'

export const sortItemsBySortKey = (items, sortKey) => {
  return sortKey === 'maxFavoriteAdded'
    ? items.sort((a, b) => {
        return compareDesc(a.maxFavoriteAdded, b.maxFavoriteAdded)
      })
    : sortBy(items, i => i[sortKey])
}
